import PSSAvatar from './PSSAvatar';

export default PSSAvatar;
